import { render, staticRenderFns } from "./ChangeContentText.vue?vue&type=template&id=323d981a"
import script from "./ChangeContentText.vue?vue&type=script&lang=js"
export * from "./ChangeContentText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports